import { Component, OnInit, Input } from '@angular/core';
import { LoanService } from 'app/credit/services/loan.service';
 



@Component({
  selector: 'approval-comment-tab',
  templateUrl: './approval-comment-tab.component.html',
 // styleUrls: ['./approval-comment-tab.component.scss']
})
export class ApprovalCommentTabComponent implements OnInit {
  approvalWorkflowData: any;
  @Input() operationId;
  @Input() target;

  constructor(private loanService: LoanService,) { }

  ngOnInit() {
    this.getApprovalWorkFlow(this.operationId,this.target)
  }

  getApprovalWorkFlow(operationId, target) {
    this.loanService.getApprovalTrailByOperation(operationId, target).subscribe((res: any) => {
      this.approvalWorkflowData = res.result;
    });
  }

}
